import React from "react";

const Waiting = ({style = {}, size = "36", className = "", fill="#4E525F", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M28.667 8.437V5.629A2.657 2.657 0 0 0 30 3.333v-.666A.665.665 0 0 0 29.333 2H6.667A.666.666 0 0 0 6 2.667v.666c0 .983.54 1.834 1.333 2.296v2.808a9.346 9.346 0 0 0 3.09 6.937L13.341 18l-2.918 2.626a9.346 9.346 0 0 0-3.09 6.937v2.808A2.658 2.658 0 0 0 6 32.667v.666a.666.666 0 0 0 .667.667h22.666a.665.665 0 0 0 .667-.667v-.666c0-.983-.54-1.834-1.333-2.296v-2.808a9.346 9.346 0 0 0-3.09-6.937L22.659 18l2.918-2.626a9.346 9.346 0 0 0 3.09-6.937Zm-4.874 4.956-4.018 3.616a1.331 1.331 0 0 0 0 1.982l4.018 3.616A6.679 6.679 0 0 1 26 27.563V30h-1.667l-5.8-7.733c-.251-.336-.815-.336-1.066 0L11.667 30H10v-2.437c0-1.887.805-3.693 2.207-4.956l4.018-3.616a1.332 1.332 0 0 0 0-1.982l-4.018-3.617A6.679 6.679 0 0 1 10 8.438V6h16v2.437a6.678 6.678 0 0 1-2.207 4.956Z"
        />
        <path
            className="u_fill"
            fill={fill}
            d="M22.595 11.333h-9.19a.667.667 0 0 0-.494 1.115l4.642 4.282a.663.663 0 0 0 .894 0l4.642-4.282a.665.665 0 0 0-.494-1.115Z"
        />
    </svg>
);

export default Waiting;